<template>
  <div class="background-theme">
    <navbar></navbar>
    <router-view></router-view>
    <img :src="BackImg" alt="background" class="background-image" />
  </div>
</template>

<script>
import Navbar from './components/Navebar.vue'
import BackImg from './assets/asanka.png'

 export default {
   data() {
     return {
       BackImg,
     }
   },
   components:{
    'navbar' :Navbar,
   }
 }
</script>

<style>
 .background-theme {
   background: #c4c4c4;
   height: 102vh;
 }

 .background-image {
   position:absolute ;
   height:97%;
   bottom:0px;
   right:0px;
 }
 .navback {
   background: #c4c4c4;
   opacity:53%;
 }
</style>
